const styles = theme => ({
    ModelContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '10px 10px'
    },
    modelGridList: {
        padding: '10px 10px',
        margin: '10px 10px'//,
//        height: '200px'
    },
    header3: {
        width: '80%',
        padding: '10px 20px',
        backgroundColor: 'rgba(94, 112, 247, 1)',
        color: 'white',
        display: 'flex',
        justifyContent: 'center'
    },
    rightIcon: {
        marginLeft: theme.spacing.unit,
    },
    gridTile: {
        // height: '200px'
    },
    selectableModel: {
        '&:hover': {
            border: '2px solid rgba(235, 235, 235, 1)'
        },
        borderRadius: '5px',
//        height: '300px'
    },
    selectedModel: {
        border: '3px solid rgba(94, 112, 247, 1)',
        '&:hover': {
            border: '3px solid rgba(94, 112, 247, 1)'
        }
    },
    modelImageContainer: {
        position: 'relative'
    },
    modelImage: {
        width: '100%',
        height: 'auto'
    },
    activeImage: {
        position: 'absolute',
        transition: '0.5s',
        backgroundColor: 'white',
        // '&:hover':{
        //     height: '300px',
        //     width: 'auto',
        //     transition: '2s'
        // }
        '&:hover':{
            opacity: 0
        }
    }
});

export default styles;
